export const AUTH_INVALID_EVENT = "smartpay:auth-invalid";
export const CONTEXT_INVALID_EVENT = "smartpay:context-invalid";

const CLIENT_KEYS = [
  "client",
  "guestClient",
  "addressNowLocation",
];

const BRANCH_CONTEXT_KEYS = [
  "branchoffice",
  "machine",
  "branchoffice_original",
  "machine_original",
  "generalData",
  "publicity",
  "Detail_order",
  "selectedCategorie",
  "table",
  "codeRoom",
];

const BUSINESS_CONTEXT_KEYS = [
  "business",
  "businessConfig",
  "frecuentShopperConfig",
  "logo",
  "iconGeneral",
  "branchofficesByEvent",
  "dataEvent",
];

export function safeJsonParse(value, fallback = null) {
  if (!value || value === "undefined" || value === "null") return fallback;

  try {
    return JSON.parse(value);
  } catch (err) {
    return fallback;
  }
}

export function clearClientSession() {
  CLIENT_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function clearInvalidBranchContext() {
  BRANCH_CONTEXT_KEYS.forEach((key) => localStorage.removeItem(key));
  clearClientSession();
}

export function clearInvalidBusinessContext() {
  BUSINESS_CONTEXT_KEYS.forEach((key) => localStorage.removeItem(key));
  clearInvalidBranchContext();
}

export function emitAuthInvalid(detail = {}) {
  window.dispatchEvent(new CustomEvent(AUTH_INVALID_EVENT, { detail }));
}

export function emitContextInvalid(detail = {}) {
  window.dispatchEvent(new CustomEvent(CONTEXT_INVALID_EVENT, { detail }));
}

export function normalizeClient(data = {}) {
  const client = data?.data?.client || data?.client || data?.data || data;

  if (!client || typeof client !== "object") return null;

  return {
    id: client.id ?? client.client_id,
    phone: client.phone,
    name: client.name,
    nickname: client.nickname,
    business_id: client.business_id,
    email: client.email,
    user_code: client.user_code,
    gender: client.gender,
    lastname: client.lastname,
    cloudinary_id: client.cloudinary_id ?? null,
    client_type_id: client.client_type_id,
    client_qr_url: client.client_qr_url ?? null,
    ruc: client.ruc,
    dv: client.dv,
    client_ruc_type: client.client_ruc_type,
    billing_name: client.billing_name,
    localization: client.localization ?? null,
    is_validated: client.is_validated ?? 0,
    pass: "",
    points: client.points ?? 0,
  };
}

